const BillingReports = () => {
  return <div>BillingReports</div>;
};

export default BillingReports;
